import SiteHeader from "./components/site-header";
// import CookiesConsent from "./components/cookies-consent";

import DeviceManager from "./utils/device-manager";

import '../sass/style.scss';

(function ($) {
	window.$ = $;

	$(function () {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}

		// General components
		const siteHeader = new SiteHeader($(".site-header"), 20);
		// const dropdownMenu = new DropdownMenu($('.header__nav'));

		// Cookie consent
		// if (typeof tarteaucitron !== "undefined" && tarteaucitron && false) {
			// Tarteaucitron cookie settings
			// let tarteaucitronLang = "fr";

			// const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		// }

		// Menu mobile 
		$(".site-header__menu-toggler").click(function () {
			if ($(this).attr("aria-expanded") === "true") {
				$(this).attr("aria-expanded", "false");
				console.log($(this).attr("aria-expanded"));
			}
			else if ($(this).attr("aria-expanded") === "false") {
				$(this).attr("aria-expanded", "true");
				console.log($(this).attr("aria-expanded"));
			}
		});

		// Back to top
		$(window).scroll(function () {
			var scroll = $(window).scrollTop();

			if (scroll >= 800) {
				$(".back-to-top").addClass("is-visible");
			} else {
				$(".back-to-top").removeClass("is-visible");
			}
		});

		// Décalage du scroll
		var anchorLink = $(window.location.hash);
		
		if ( anchorLink.length ) {
			$("html, body").animate({scrollTop: anchorLink.offset().top - 100 }, 200);
		}

		function scrollToAnchor(hash) {
            var target = $(hash),
                headerHeight = 100; 

            if(target.parents('.scroll-in-view').hasClass('scroll-in-view--slide-y')) {
                if(target.parents('.scroll-in-view').hasClass('scroll-in-view-anim-ended')) {
                    headerHeight = 100;
                } else {
                    headerHeight = 200;
                }
            }

            if (target.length)
            {
                //console.log(target.offset().top, headerHeight, target.offset().top - headerHeight);
                $('html,body').animate({
                    scrollTop: target.offset().top - headerHeight
                }, 500);
                
                return false;
            }
        }

        $(window).on('fonts:ready', function() {
            //console.log('fonts:ready');
            if(window.location.hash) {
                scrollToAnchor(window.location.hash);
            }
        });

        $("a[href*=\\#]:not([href=\\#])").click(function(){
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
            || location.hostname == this.hostname)
            {
                scrollToAnchor(this.hash);
            }
        });
	});
})(jQuery);
